import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GetAllStructureRows, resetGetAllStatus } from "./slice"

export function StruttureList() {
    const dispatch = useAppDispatch()
    const structureState = useAppSelector(state => state.notificationStructure)
    const notificationState = useAppSelector(state => state.notification)

    useEffect(() => {
        dispatch(GetAllStructureRows({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
    }, [])

    useEffect(() => {
        if (structureState.getAllStructureRowsStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [structureState.getAllStructureRowsStatus])

    return (
        <div style={{ padding: '24px' }}>
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">N. UP</th>
                        <th className="width-[130px]">Attività</th>
                        <th className="width-[100px]">Tipo</th>
                        <th className="width-[130px]">Cod. Belfiore</th>
                        <th className="width-[130px]">Sez.</th>
                        <th className="width-[130px]">Foglio</th>
                        <th className="width-[130px]">Particella</th>
                        <th className="width-[130px]">Sub</th>
                        <th className="width-[130px]">Indirizzo</th>
                        <th className="width-[130px]">Possesso</th>
                        <th className="width-[130px]">Utilizzo</th>
                        <th className="width-[130px]">Superfice</th>
                        <th className="width-[130px]">Metodo</th>
                        <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        structureState.GetAllStructureResponse?.data.map((s, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td></td>
                                <td>{s.productiveUnitNumber}</td>
                                <td>{s.activity}</td>
                                <td>{s.type}</td>
                                <td>{s.cadastralCode}</td>
                                <td>{s.section}</td>
                                <td>{s.sheet}</td>
                                <td>{s.parcel}</td>
                                <td>{s.sub}</td>
                                <td>{s.address}</td>
                                <td>{s.ownership}</td>
                                <td>{s.usage}</td>
                                <td>{s.area}</td>
                                <td>{s.method}</td>
                                <td></td>
                            </tr>
                        )}
                </tbody>
            </table>
        </div>
    )
}